<template>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-note>Engin</ion-note>
        <div
          :class="
            tools
              ? 'align-detail-img mt-15'
              : 'justify-content-center align-detail-img mt-15'
          "
        >
          <ion-img
            class="width-machine-detail-mission mb-5"
            :src="
              getImageForCategory(machine_category + '-' + machine_translation)
            "
          />
          <div class="text-align-center">
            <ion-label class="ml-10"
              >{{
                machine_number
                  ? machine_name + ' - ' + machine_number
                  : machine_name
              }}<br v-if="voiture_pilote" /><ion-badge
                v-if="voiture_pilote"
                color="success"
                class="ml-10"
                >VP</ion-badge
              ></ion-label
            >
          </div>
        </div>
      </ion-col>
      <ion-col v-if="tools" class="border-left-grey">
        <ion-note>Outil(s)</ion-note>
        <div class="align-detail-img mt-13">
          <ion-img
            class="width-icon-img-30 mr-10 mb-5"
            src="/assets/icon/tool.svg"
          />
          <ion-label
            class="text-align-center"
            v-for="tool in tools"
            :key="tool.id"
            >{{ tool.name }}</ion-label
          >
        </div>
      </ion-col>
    </ion-row>

    <ion-row
      v-if="missionId && attachments && attachments.length"
      class="ion-justify-content-end"
    >
      <ion-button
        :id="'open-machine-modal-' + missionId"
        expand="block"
        color="light"
        size="small"
      >
        Documents&nbsp;<strong>matériel</strong>
      </ion-button>

      <attachments-modal
        :trigger="'open-machine-modal-' + missionId"
        :categories="computedAttachments"
      />
    </ion-row>

    <hr class="color-hr" v-if="displayDumpBodyPart" />

    <ion-row v-if="displayDumpBodyPart">
      <ion-col>
        <div class="dump-body-heading">
          <ion-note>Remorque</ion-note>

          <ion-button
            @click="openChangeDumpBodyModal()"
            expand="block"
            color="light"
            size="small"
          >
            <ion-icon slot="start" :icon="pencilOutline"></ion-icon>
            Changer la remorque
          </ion-button>
        </div>

        <div class="align-detail-img mt-13">
          <ion-img
            class="width-icon-img-30 mr-10 mb-5"
            src="/assets/icon/dump-body.svg"
          />

          <ion-label v-if="dumpBody">{{ dumpBody.name }}</ion-label>
          <ion-label v-else>Pas de remorque</ion-label>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import {
  IonGrid,
  IonRow,
  IonCol,
  IonNote,
  IonLabel,
  IonImg,
  IonBadge,
  IonButton,
  IonIcon,
  modalController,
} from '@ionic/vue';
import { sendErrorToast } from '@/services/utils/toastUtils';
import utils from '@/services/utils/enginUtils';
import AttachmentsModal from './sub-components/AttachmentsModal.vue';
import ChangeDumpBodyModal from './ChangeDumpBodyModal.vue';
import { pencilOutline } from 'ionicons/icons';

export default {
  name: 'Equipment',
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonNote,
    IonLabel,
    IonImg,
    IonBadge,
    IonButton,
    IonIcon,
    AttachmentsModal,
  },

  props: {
    machine_name: String,
    machine_category: String,
    machine_number: String,
    machine_translation: String,
    machine_poids: String,
    tools: {},
    dumpBody: null,
    dumpBodies: Array,
    displayDumpBodyPart: Boolean,
    // if not null, prevent click, and display message as toast instead
    disableChangeDumpBodyMessage: String,
    voiture_pilote: Boolean,
    attachments: Array,
    transportId: Number,

    // To handle modal trigger
    missionId: Number,
  },

  setup() {
    return {
      pencilOutline,
    };
  },

  methods: {
    getImageForCategory: utils.getImageForCategory,

    async openChangeDumpBodyModal() {
      if (this.disableChangeDumpBodyMessage) {
        sendErrorToast(this.disableChangeDumpBodyMessage, 'top', 5000);
        return;
      }

      const eventId = this.transportId ? this.transportId : this.missionId;
      const eventKind = this.transportId ? 'transport' : 'reservation';

      const modal = await modalController.create({
        component: ChangeDumpBodyModal,
        componentProps: {
          dumpBodies: this.dumpBodies,
          eventKind,
          eventId,
        },
      });
      await modal.present();

      const { data } = await modal.onDidDismiss();

      if (data) {
        this.$emit('refresh-mission');
      }
    },
  },

  computed: {
    computedAttachments() {
      return [{ name: 'Documents matériel', attachments: this.attachments }];
    },
  },
};
</script>

<style scoped lang="scss">
.width-machine-detail-mission {
  max-width: 50px;
  max-height: 50px;
}

.dump-body-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
</style>
